import React from 'react';
import { Button } from 'reactstrap';

class RateButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEarnedPointRight: false,
      hardQuestion: true,
      showPlusOne: true,
      plusOnePosition: 'text-center',
    };

    this.plusOneTimeout = null;
  }

  componentWillUnmount() {
    clearTimeout(this.plusOneTimeout);
  }

  getHardValue = () => {
    if (this.props.isPreviewMode) {
      return;
    }

    if (
      this.props.question.displaymode === 'MultipleOption' &&
      !this.props.isCorrect
    ) {
      return '1 minute';
    }

    const correctAnswerTime =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.hard?.days
        : this.props.question.flashcardCorrectAnswer?.wrong?.days || 1;

    const day = correctAnswerTime
      ? correctAnswerTime > 1
        ? 'days'
        : 'day'
      : null;
    const minutesValue =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.hard?.minutes
        : (this.props.question.flashcardCorrectAnswer?.wrong?.minutes ?? 10);

    return minutesValue
      ? `${minutesValue} minutes`
      : `${correctAnswerTime} ${day}`;
  };

  componentDidUpdate(prevProps) {
    if (this.props.clicked && !prevProps.clicked) {
      this.setState({ showPlusOne: true });
    }
  }

  getNormalValue = () => {
    if (
      this.props.question.displaymode === 'MultipleOption' &&
      !this.props.isCorrect
    ) {
      return '10 minutes';
    }
    const correctAnswerTime =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.normal?.days
        : this.props.question.flashcardCorrectAnswer?.correct?.days;
    const day = correctAnswerTime
      ? correctAnswerTime > 1
        ? 'days'
        : 'day'
      : null;
    const minutesValue =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.normal?.minutes
        : this.props.question.flashcardCorrectAnswer?.correct?.minutes;
    return minutesValue
      ? `${minutesValue} minutes`
      : `${correctAnswerTime} ${day}`;
  };

  getEasyValue = () => {
    if (
      this.props.question.displaymode === 'MultipleOption' &&
      !this.props.isCorrect
    ) {
      return '1 day';
    }
    const correctAnswerTime =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.easy?.days
        : this.props.question.flashcardCorrectAnswer?.easy?.days;
    const day = correctAnswerTime
      ? correctAnswerTime > 1
        ? 'days'
        : 'day'
      : null;
    const minutesValue =
      this.props.question.displaymode === 'MultipleOption'
        ? this.props.question.correctAnswer?.easy?.minutes
        : this.props.question.flashcardCorrectAnswer?.easy?.minutes;
    return minutesValue
      ? `${minutesValue} minutes`
      : `${correctAnswerTime} ${day}`;
  };

  pointAnimation = (e) => {
    if (this.props.question.flashMode || this.props.isCorrect) {
      let buttonValue;
      switch (e.target.id) {
        case 'rateDifficultyEasyButton':
          buttonValue = this.getEasyValue();
          this.setState({ plusOnePosition: 'text-right' });
          break;
        case 'rateDifficultyNormalButton':
          buttonValue = this.getNormalValue();
          this.setState({ plusOnePosition: 'text-center' });
          break;
        case 'rateDifficultyHardButton':
          buttonValue = this.getHardValue();
          this.setState({ plusOnePosition: 'text-left' });
          break;
        default:
          buttonValue = null;
      }

      buttonValue = String(buttonValue);
      if (!buttonValue.includes('minute')) {
        this.setState({ hardQuestion: false });
        this.showPlusOne();
      } else {
        this.setState({ hardQuestion: true });
      }
    }
    if (!this.props.isCorrect) {
      this.setState({ hardQuestion: true });
    }
  };

  showPlusOne = () => {
    this.setState({ showPlusOne: false });
    this.plusOneTimeout = setTimeout(() => {
      this.setState({ showPlusOne: true });
    }, 1500);
  };

  render() {
    const hard = this.getHardValue();
    const normal = this.getNormalValue();
    const easy = this.getEasyValue();

    // this is needed to parse the right element depending on the card type
    const hardClass = `hard ${
      this.props.clickedHard === true ? ' clicked' : ''
    }`;
    const normalClass = `normal btn-secondary ${
      this.props.clickedNormal === true ? ' clicked' : ''
    }`;
    const easyClass = `easy btn-secondary ${
      this.props.clickedEasy === true ? ' clicked' : ''
    }`;

    const dontEarnPoints = this.props?.question?.submittedByMe;
    return (
      <div className="rate-buttons row text-center">
        <div className="container-next mb-2 mt-2">
          {this.props.clicked === true && (
            <Button
              className="next"
              id="rateDifficultyNormalButton"
              onClick={(e) => {
                this.props.addCountQuestions();
                this.props.setFavoriteMessageAction('');
                if (this.props.user?.id) {
                  if (this.props.user.isFreeAccount) {
                    this.props.openFreePopUp(true);
                  } else if (!this.props.user.active) {
                    this.props.openCancelPopUp(true);
                  } else {
                    this.props.handleSendAnswer('Normal');
                  }

                  this.pointAnimation(e);
                }
              }}
              disabled={this.props.isLoadingQuestions}
            >
              NEXT QUESTION
            </Button>
          )}
        </div>
        {this.props.clicked === true && (
          <div className="col-12 mb-1" data-test="rate-difficulty-label">
            <b>RATE DIFFICULTY TO SEE NEXT QUESTION</b>
          </div>
        )}
        {!this.props.showPreviousAnswer && !dontEarnPoints && (
          <div className={`col-12 ${this.state.plusOnePosition}`}>
            {(this.state.showPlusOne && !this.props.resetChapter) ||
            this.props.flashcard === 'flashcardOnly' ? (
              <span className="plus-one" />
            ) : (
              <span className="plus-one showed-up">+1pt</span>
            )}
          </div>
        )}
        <div className="col-12">
          <div className="row">
            {this.props.clicked === true && (
              <div className="col-4 d-flex flex-column">
                <Button
                  className={hardClass}
                  id="rateDifficultyHardButton"
                  data-test="rate-difficulty-hard-button"
                  onClick={(e) => {
                    this.props.addCountQuestions();
                    this.props.setFavoriteMessageAction('');
                    if (this.props.user?.id) {
                      if (this.props.user.isFreeAccount) {
                        this.props.openFreePopUp(true);
                      } else if (!this.props.user.active) {
                        this.props.openCancelPopUp(true);
                      } else {
                        this.props.handleSendAnswer('Hard');
                      }
                      this.pointAnimation(e);
                    }
                  }}
                  disabled={this.props.isLoadingQuestions}
                >
                  {this.props.question.flashMode ? 'WRONG' : 'HARD'}
                </Button>
                <i>{hard}</i>
              </div>
            )}
            {this.props.clicked === true && (
              <div className="col-4 d-flex flex-column">
                <Button
                  className={normalClass}
                  id="rateDifficultyNormalButton"
                  data-test="rate-difficulty-normal-button"
                  onClick={(e) => {
                    this.props.addCountQuestions();
                    this.props.setFavoriteMessageAction('');
                    if (this.props.user && this.props.user.id) {
                      if (this.props.user.isFreeAccount) {
                        this.props.openFreePopUp(true);
                      } else if (!this.props.user.active) {
                        this.props.openCancelPopUp(true);
                      } else {
                        this.props.handleSendAnswer('Normal');
                      }

                      this.pointAnimation(e);
                    }
                  }}
                  disabled={this.props.isLoadingQuestions}
                >
                  {this.props.question.flashMode ? 'CORRECT' : 'NORMAL'}
                </Button>
                <i>{normal}</i>
              </div>
            )}
            {this.props.clicked === true && (
              <div className="col-4 d-flex flex-column">
                <Button
                  className={easyClass}
                  id="rateDifficultyEasyButton"
                  data-test="rate-difficulty-easy-button"
                  onClick={(e) => {
                    this.props.addCountQuestions();
                    this.props.setFavoriteMessageAction('');
                    if (this.props.user?.id) {
                      if (this.props.user.isFreeAccount) {
                        this.props.openFreePopUp(true);
                      } else if (!this.props.user.active) {
                        this.props.openCancelPopUp(true);
                      } else {
                        this.props.handleSendAnswer('Easy');
                      }
                      this.pointAnimation(e);
                    }
                  }}
                  disabled={this.props.isLoadingQuestions}
                >
                  {this.props.question.flashMode ? 'EASY' : 'EASY'}
                </Button>
                <i>{easy}</i>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default RateButtons;
